import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapPolygonMode } from "mapbox-gl-draw-snap-mode";

import { clip } from "fond/draw/helper";
import { feature } from "fond/turf";

import { removeGuides } from "./helper";

const {
  constants: Constants,
  lib: { doubleClickZoom },
} = MapboxDraw;

const drawPolygon: DrawCustomMode = {
  ...SnapPolygonMode,

  onSetup: function onSetup(opts) {
    const state = SnapPolygonMode.onSetup?.call(this, opts);
    state.options = this._ctx.options;
    removeGuides.call(this);

    return state;
  },

  /**
   * We customize the onStop method to clip the polygon to other polygons if
   * autoClip is enabled. Otherise we use the default SnapPolygonMode onStop.
   * @param state The current state of the mode.
   * @returns void
   */
  onStop(state) {
    if (state.options?.autoClip) {
      this.updateUIClasses({ mouse: Constants.cursors.NONE });
      doubleClickZoom.enable(this);
      this.activateUIButton();

      // check to see if we've deleted this feature
      if (this.getFeature(state.polygon.id) === undefined) return;

      // remove last added coordinate
      state.polygon.removeCoordinate(`0.${state.currentVertexPosition}`);
      // clip the polygon to other polygons
      // this will remove any overlapping coordinates
      const newCoords = clip(
        feature(state.polygon),
        this._ctx.api.getAll().features.filter(({ id }) => id !== state.polygon.id)
      );
      // update the polygon with the clipped coordinates
      state.polygon.setCoordinates(newCoords.geometry.coordinates);

      if (state.polygon.isValid()) {
        // Here we need to clip the polygon to other polygons
        this.map.fire(Constants.events.CREATE, {
          features: [state.polygon.toGeoJSON()],
        });
      } else {
        this.deleteFeature(state.polygon.id, { silent: true });
        this.changeMode(Constants.modes.SIMPLE_SELECT, {}, { silent: true });
      }
    } else {
      SnapPolygonMode.onStop?.call(this, state);
    }
  },
};

export default drawPolygon;
